import React, { useEffect, useState } from "react";

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "";

const MapEmbed: React.FC = () => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/map`)
      .then((r) => r.json())
      .then((data: { available: boolean; url?: string }) => {
        if (data.available && data.url) setUrl(data.url);
      })
      .catch(() => {});
  }, []);

  if (!url) return null;

  return (
    <div className="footer-map">
      <iframe
        src={url}
        title="J&S Audio Video Solutions location on Google Maps"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default MapEmbed;
